module.exports = ".faq-page .faq-page-content {\n  padding: 0 5%; }\n  @media (min-width: 768px) {\n    .faq-page .faq-page-content {\n      padding: 0 15% 0 15%; } }\n  .faq-page .faq-page-content hr {\n    margin: 2rem 0 2rem 0; }\n  .faq-page .faq-page-content .faq-text {\n    font-size: 1.2rem; }\n  @media (min-width: 768px) {\n      .faq-page .faq-page-content .faq-text {\n        font-size: 1.4rem; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/study-container-page/faq-page/faq-page.scss
// module id = ./src/app/pages/study-container-page/faq-page/faq-page.scss
// module chunks = main